import { RootState } from "../../store";
import { GcpConnectionType } from "../../../components/pages/common/connectors/components/gcp/utils/types";

export const gcpConnectionTypeSelector = (
  state: RootState,
): GcpConnectionType => state.accountSetup.gcpConnectionType;
